// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import watchSquareIcon from "@/assets/icons/watch-square.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type WatchSquareIconProps = Omit<IconProps, "name">;

export function WatchSquareIcon(props: WatchSquareIconProps): React.ReactNode {
  return <Icon name={watchSquareIcon} {...props} />;
}
